import { SectionConfigBuilder } from '../ThemeConfigBuilder';
import { body, byline, headline, overline } from '../fields/fields';

export default new SectionConfigBuilder()
  .setContext('picker', {
    label: 'Post',
    description: 'Show off your posts',
    icon: 'Post',
  })
  .setContext('editor', {
    label: 'Post Section',
    description: '',
    icon: 'Post',
  })
  .addLayout('layout1', (layout) => {
    layout
      .setIcon('PostLayout1')
      .setInsetBlock((block) => {
        block.setText([overline, headline, body]);
        block.setMedia(0);
        block.setActions(Infinity);
      })
      .addBlock((block) => {
        block.setText([overline, headline, byline, body]);
        block.setMedia(0);
        block.setActions(Infinity);
      })
      .setBlockVariants({
        label: 'Desktop Post Placement',
        controlType: 'left right',
        options: [
          {
            value: 'variant1',
            label: 'Left',
          },
          {
            value: 'variant2',
            label: 'Right',
          },
        ],
      })
      .setBlockVariantsMobile({
        label: 'Mobile Post Placement',
        controlType: 'top bottom',
        options: [
          {
            value: 'variant1',
            label: 'Top',
          },
          {
            value: 'variant2',
            label: 'Bottom',
          },
        ],
      });
  })
  .addLayout('layout2', (layout) => {
    layout
      .setIcon('PostLayout2')
      .setInsetBlock((block) => {
        block.setText([overline, headline, body]);
        block.setMedia(0);
        block.setActions(Infinity);
      })
      .addBlock((block) => {
        block.setText([overline, headline, byline, body]);
        block.setMedia(0);
        block.setActions(Infinity);
      })
      .setBlockVariants({
        label: 'Post Placement',
        controlType: 'top bottom',
        options: [
          {
            value: 'variant1',
            label: 'Top',
          },
          {
            value: 'variant2',
            label: 'Bottom',
          },
        ],
      });
  })
  .addLayout('layout3', (layout) => {
    layout
      .setIcon('PostLayout3')
      .setInsetBlock((block) => {
        block.setText([overline, headline, body]);
        block.setMedia(0);
        block.setActions(Infinity);
      })
      .addBlock((block) => {
        block.setText([overline, headline, byline, body]);
        block.setMedia(3);
        block.setActions(Infinity);
      })
      .setBlockVariants({
        label: 'Image Placement',
        controlType: 'top bottom',
        options: [
          {
            value: 'variant1',
            label: 'Top',
          },
          {
            value: 'variant2',
            label: 'Bottom',
          },
        ],
      });
  })
  .addLayout('layout4', (layout) => {
    layout
      .setIcon('PostLayout4')
      .setInsetBlock((block) => {
        block.setText([overline, headline, body]);
        block.setMedia(0);
        block.setActions(Infinity);
      })
      .addBlock((block) => {
        block.setText([overline, headline, byline, body]);
        block.setMedia(0);
        block.setActions(Infinity);
      })
      .setBlockBodyMaxColumns(3);
  })
  .addLayout('layout5', (layout) => {
    layout
      .setIcon('PostLayout5')
      .setInsetBlock((block) => {
        block.setText([overline, headline, body]);
        block.setMedia(0);
        block.setActions(Infinity);
      })
      .addBlock((block) => {
        block.setText([overline, headline, byline, body]);
        block.setMedia(0);
        block.setActions(Infinity);
      });
  })
  .addLayout('layout6', (layout) => {
    layout
      .setDescription('Post Only')
      .setIcon('PostLayout6')
      .setInsetBlock((block) => {
        block.setText([overline, headline, body]);
        block.setMedia(0);
        block.setActions(0);
      })
      .addBlock((block) => {
        block.setText([]);
        block.setMedia(0);
        block.setActions(0);
      });
  })
  .build();

